import { observer } from 'mobx-react-lite';
import { optionsFull_search_noResults } from '../../strings.locstring.json';
import { optionsFull_searchPlaceholder } from './FullOptionSearch.locstring.json';
import loc from 'owa-localize';
import { setSearchTerm, getSearchResults, getQuery } from 'owa-options-search';
import { SearchBox, ISearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { FocusZone, FocusZoneDirection, IFocusZone } from 'office-ui-fabric-react/lib/FocusZone';
import { useId } from '@uifabric/react-hooks';
import * as React from 'react';
import OptionSearchSuggestion from './OptionSearchSuggestion';
import { CommandButton } from 'office-ui-fabric-react/lib/Button';

const styles = require('./OptionsFull.scss');

export default observer(function FullOptionSearch(props: {}) {
    const searchBoxId = useId('optionSearch');
    const searchBox = React.useRef<ISearchBox>();
    const suggestionFocusZone = React.useRef<IFocusZone>();
    const onSearchBoxKeyDown = (ev: React.KeyboardEvent<HTMLDivElement>) => {
        if (ev.key === 'ArrowDown') {
            suggestionFocusZone.current.focus();
            ev.stopPropagation();
            ev.preventDefault();
        }
    };
    const onFirstOptionKeyDown = (ev: React.KeyboardEvent<HTMLButtonElement>) => {
        switch (ev.key) {
            case 'ArrowUp':
                if (ev.currentTarget.dataset.optionIndex === '0') {
                    searchBox.current.focus();
                    break;
                } else {
                    return;
                }
            case 'Escape':
                setSearchTerm(null, '');
                searchBox.current.focus();
                break;
            default:
                // don't stop propagation or prevent default
                return;
        }
        ev.stopPropagation();
        ev.preventDefault();
    };
    const suggestionFocusZoneRef = (ref: IFocusZone) => {
        suggestionFocusZone.current = ref;
    };
    let suggestedOptions = getSearchResults();
    let showSuggestions = suggestedOptions && suggestedOptions.length > 0;
    return (
        <div onKeyDown={showSuggestions ? onSearchBoxKeyDown : undefined}>
            <SearchBox
                id={searchBoxId}
                componentRef={searchBox}
                labelText={loc(optionsFull_searchPlaceholder)}
                title={loc(optionsFull_searchPlaceholder)}
                className={styles.searchBox}
                value={getQuery()}
                onChange={setSearchTerm}
            />
            {getQuery().trim().length > 0 && (
                <Callout
                    target={`#${searchBoxId}`}
                    isBeakVisible={false}
                    className={styles.suggestionCallout}>
                    {showSuggestions ? (
                        <FocusZone
                            direction={FocusZoneDirection.vertical}
                            componentRef={suggestionFocusZoneRef}>
                            {suggestedOptions.map((option, index) => (
                                <OptionSearchSuggestion
                                    key={option.key}
                                    option={option}
                                    onKeyDown={onFirstOptionKeyDown}
                                    data-option-index={index}
                                />
                            ))}
                        </FocusZone>
                    ) : (
                        <CommandButton
                            className={styles.noSuggestions}
                            disabled={true}
                            text={loc(optionsFull_search_noResults)}
                        />
                    )}
                </Callout>
            )}
        </div>
    );
});
